export const alertmodal = state => state.alertmodal;

export const isExistInMyIndexes = state => name => {
  return state.myIndexes.find(item => item.display_name == name);
};



// WEBPACK FOOTER //
// ./src/store/getters.js